import { render, staticRenderFns } from "./Wicon.vue?vue&type=template&id=c31e25fc&scoped=true&"
import script from "./wicon.ts?vue&type=script&lang=ts&"
export * from "./wicon.ts?vue&type=script&lang=ts&"
import style0 from "./Wicon.vue?vue&type=style&index=0&id=c31e25fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31e25fc",
  null
  
)

export default component.exports